
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage-v2/[client]/minutes/[minutes]",
      function () {
        return require("private-next-pages/engage-v2/[client]/minutes/[minutes].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage-v2/[client]/minutes/[minutes]"])
      });
    }
  